<template lang="pug">
  .page-tab-container(
    :class="{ 'ceiling': isCeiling }"
    :style="{ backgroundColor: isCeiling ? '#fff' : tabBgColor }"
  )
    .page-tab-item(
      v-for="tab in tabs" :key="tab.key"
      :class="{ 'active': activeTab === tab.key }"
      :style="{ backgroundColor: activeTab === tab.key ? getTabActiveColor(tab) : 'transparent' }"
      @click="handleTabClick(tab.key)"
    )
      span {{ tab.tabName }}
</template>

<script>
import SPM from '../common/spm';
import { WELFARE_CENTER_TABS_CONFIG } from '../consts';

export default {
  name: 'PageTab',
  props: {
    // 是否吸顶
    isCeiling: {
      type: Boolean,
      default: false,
    },
    // 默认激活的tab
    defaultActiveTab: {
      type: String,
      default: 'bounty',
    },
  },
  data() {
    return {
      // 当前激活的tab
      activeTab: 'bounty',
      // 页面tab配置
      tabs: WELFARE_CENTER_TABS_CONFIG,
    };
  },
  computed: {
    tabBgColor() {
      const tabInfo = this.tabs.find((tab) => tab.key === this.activeTab) || {};
      return tabInfo.tabBgColor || '';
    },
  },
  mounted() {
    this.activeTab = this.defaultActiveTab;

    SPM.moduleExpose({
      moduleId: 'platform_twoTab',
      contentId: 'platform_twoTab',
      businessInfo: {},
    });
  },
  methods: {
    // 处理tab点击
    handleTabClick(key) {
      if (this.activeTab === key) return;
      this.activeTab = key;
      this.$emit('changeTab', key);

      SPM.clickButton({
        buttonName: 'platform_twoTab',
        businessInfo: {
          tab_name: key,
        },
      });
    },
    // 获取tab激活颜色
    getTabActiveColor(tab) {
      return this.isCeiling ? tab.tabActiveColor : '#fff';
    },
  },
};
</script>

<style lang="less" scoped>
.page-tab-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.03rem;
  width: 100%;
  height: 0.44rem;
  border-radius: 0.16rem;
  background-color: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  box-sizing: border-box;
  border: 0.01rem solid rgba(255, 255, 255, 0.6);
  transition: all 0.3s ease;

  .page-tab-item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 0.38rem;
    border-radius: 0.13rem;
    font-size: 0.15rem;
    color: #242729;
    line-height: normal;
    transition: all 0.3s ease;
    margin: 0 -0.005rem;
    transform: translateY(-0.002rem);

    &.active {
      background-color: #fff;
      font-weight: 600;
      font-size: 0.16rem;
    }
  }

  &.ceiling {
    padding: 0 0.02rem;
    width: 2.12rem;
    height: 0.35rem;
    border-radius: 0.28rem;
    background-color: #fff;

    .page-tab-item {
      height: 0.31rem;
      border-radius: 0.28rem;

      &.active {
        font-weight: 600;
        font-size: 0.16rem;
      }
    }
  }
}
</style>
